import React from "react";
import "./profileStyle.scss";
import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";

// Animation Variants for framer motion animation
const wrapperVariants = {
  opened: {
    opacity: 1,
    display: "block",
    zIndex: "5",
  },
  closed: {
    opacity: 0,
    zIndex: "-22",
  },
};

const animVariants = {
  opened: {
    opacity: 1,
    scale: 1,
    top: 70,
  },
  closed: {
    opacity: 0,
    scale: 0,
    top: 0,
  },
};

// React Functional component used to render Profile popup
export default function ProfileComponent({
  open,
  isDark,
  handleClose,
  projectCount,
  email,
  dp,
  user,
}) {
  return (
    <motion.div
      variants={wrapperVariants}
      animate={open ? "opened" : "closed"}
      initial={{ opacity: 0, zIndex: "-22" }}
      className="task-modal-wrapper"
    >
      <motion.div
        initial={{ scale: 0, top: 0, opacity: 0 }}
        variants={animVariants}
        animate={open ? "opened" : "closed"}
        className={`profile-modal ${isDark ? "profile-modal-dark" : ""} `}
      >
        <div className="header-bar">
          <button className="close-btn" onClick={handleClose}>
            <IoMdClose size={22} />
          </button>
        </div>
        <div className="user-info">
          <div className="user-name">
            <span className="user-name-welcome">Welcome</span>
            <span className="user-name-text">{user}</span>
          </div>
          <div className="user-img">
            <img src={dp} alt="" />
          </div>
        </div>
        <div className="user-details">
          <div className="user-detail-entry">
            <span>
              <strong>Email :</strong>
            </span>
            &nbsp;
            <span>{email}</span>
          </div>
          <div className="user-detail-entry">
            <span>
              <strong>Projects Created :</strong>
            </span>
            &nbsp;
            <span>{`0${projectCount}`}</span>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
